// extracted by mini-css-extract-plugin
export default {"main":"LinkCard_main__d4WCr","source":"LinkCard_source__mqDxn"};